const footerSkin = {
  footer: {
    display: "flex",
    padding: "5px",
    justifyContent: "space-between",
    alignItems: "center",
  },
  "footer-child": {
    display: "flex",
    alignItems: "center",
    "& > div": {
      paddingRight: "5px",
    },
  },
  pagination: {
    composes: "relative z-0 inline-flex rounded-md shadow-sm -space-x-px",
    margin: "0",
  },
  "page-number": {
    composes:
      "relative inline-flex items-center px-2 py-2 border border-gray-300 bg-white text-sm font-medium",
    borderRadius: "0",
    width: "100px",
  },
};

export default footerSkin;
